import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONTRACT_MENU_TAB_ITEMS, CONTRACT_MENU_TAB_OPTIONS } from 'src/app/extensions/constants/contractMenuItemTabs';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractAPIService as ContractAPIService } from 'src/app/extensions/services/api/contracts-api.service';
import { RequestEntryComponent } from '../../my-requests/request-entry/request-entry.component';
import { forkJoin } from 'rxjs';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';

@Component({
  selector: 'app-contract-detail',
  templateUrl: './contract-detail.component.html',
  styleUrls: ['./contract-detail.component.scss'],
  standalone: false,
})
export class ContractDetailComponent implements OnInit {
  public constructor(
    private _contractAPIService: ContractAPIService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _ngbModal: NgbModal,
    private _partnerAPIService: PartnerAPIService
  ) {}

  public contract: app.models.ContractDetailModel;

  public assets: app.models.ContractDetailAssetModel[];
  public assetsProps: app.models.DynamicPropsDictionary;

  public paymentSchedules: app.models.ContractDetailPaymentScheduleModel[];
  public paymentSchedulesProps: app.models.DynamicPropsDictionary;

  public collaterals: app.models.ContractDetailCollateralModel[];
  public collateralsProps: app.models.DynamicPropsDictionary;

  public insurances: app.models.ContractDetailInsuranceModel[];
  public insurancesProps: app.models.DynamicPropsDictionary;

  public currentSub: ContractDetailSub;
  public contractId: string;
  isInsurancesAvailable: boolean = true;
  ContractType = DictionaryContractType;
  tabs: app.models.ContractMenuItemsTab[] = [];
  warningMessages: string[] = [];

  public ngOnInit(): void {
    this.loadData();
    this.tabs = CONTRACT_MENU_TAB_ITEMS;
  }

  private loadData() {
    this.contractId = this._activatedRoute.snapshot.params['id'];

    forkJoin([
      this._contractAPIService.getContract(this.contractId),
      this._partnerAPIService.getPartnerRequestCreationRestrictions(),
    ]).subscribe(([contractData, requestCreationRestrictions]) => {
      this.contract = contractData;
      this.initializeSub(ContractDetailSub.Assets);
      this.tabs = this.tabs.filter(
        x => !(x.key === CONTRACT_MENU_TAB_OPTIONS.INSURANCES && !this.isInsurancesAvailable)
      );

      if (requestCreationRestrictions.isRestricted) {
        this.warningMessages.push('requests.cards.contactSupportWarning');
      }
      if (requestCreationRestrictions.hasUnpaidInvoices) {
        this.warningMessages.push('requests.cards.unpaidInvoicesWarning');
      }
    });
  }

  private initializeSub(defaultSub: ContractDetailSub) {
    let sub = localStorage.getItem('cd_sub');

    if (sub != null) {
      if (this.isInsurancesAvailable) {
        this.ensureSubDataLoaded(ContractDetailSub[sub]);
      } else {
        this.ensureSubDataLoaded(
          ContractDetailSub[sub] !== ContractDetailSub.Insurances ? ContractDetailSub[sub] : defaultSub
        );
      }
    } else {
      this.ensureSubDataLoaded(defaultSub);
    }
  }

  private ensureSubDataLoaded(sub: ContractDetailSub, updSub?: string) {
    switch (sub) {
      case ContractDetailSub.Assets:
        if (this.assets == null) {
          this._contractAPIService.getContractAssets(this.contractId).subscribe(response => {
            this.assets = response.data;
            this.assetsProps = response.props;
          });
        }
        this.currentSub = sub;
        if (updSub) localStorage.setItem('cd_sub', updSub);

        break;

      case ContractDetailSub.PaymentSchedule:
        if (this.paymentSchedules == null) {
          this._contractAPIService.getContractPaymentSchedules(this.contractId).subscribe(response => {
            this.paymentSchedules = response.data;
            this.paymentSchedulesProps = response.props;
          });
        }
        this.currentSub = sub;
        if (updSub) localStorage.setItem('cd_sub', updSub);

        break;

      case ContractDetailSub.Collaterals:
        if (this.collaterals == null) {
          this._contractAPIService.getContractCollaterals(this.contractId).subscribe(response => {
            this.collaterals = response.data;
            this.collateralsProps = response.props;
            this.currentSub = sub;
          });
        }
        this.currentSub = sub;
        if (updSub) {
          localStorage.setItem('cd_sub', updSub);
        }

        break;

      case ContractDetailSub.Insurances:
        if (this.insurances == null) {
          this._contractAPIService.getContractInsurances(this.contractId).subscribe(response => {
            this.insurances = response.data;
            this.insurancesProps = response.props;
            this.currentSub = sub;
          });
        }
        this.currentSub = sub;
        if (updSub) {
          localStorage.setItem('cd_sub', updSub);
        }
        break;
    }
  }

  public switchHandler(sub: string) {
    this.ensureSubDataLoaded(ContractDetailSub[sub], sub);
  }

  public invoicesHandler() {
    this._router.navigate(['invoices'], { queryParams: { contractId: this.contract?.contractId } });
  }

  public backHandler() {
    this._router.navigate(['contracts']);
  }

  redirectNewRequestHandler() {
    if (this.contract.dictionaryContractType.code !== this.ContractType.CREDIT) {
      const modal = this._ngbModal.open(RequestEntryComponent);
      modal.componentInstance.redirect = true;
      modal.componentInstance.requestAccessWarnings = this.warningMessages;
      modal.result.then(route => {
        if (route) {
          this._router.navigateByUrl(`${route}/new/${this.contractId}`);
        }
      });
    } else {
      this._router.navigateByUrl(`requests/contract-modifications/new/${this.contractId}`);
    }
  }
}

enum ContractDetailSub {
  Assets,
  PaymentSchedule,
  Collaterals,
  Insurances,
}
